<template>
    <div>
        <div v-if="!loaded && !error" class="text-center pa-10">
            <v-progress-circular indeterminate />
        </div>

        <div v-if="error" class="no-company">
            <v-container class="fill-height d-flex align-center justify-center">
                <v-row>
                    <v-col class="text-center">
                        <h2>{{ $t("register.noCompanyFoundTitle") }}</h2>
                        <p>{{ $t("register.noCompanyFoundMessage") }}</p>
                    </v-col>
                </v-row>
            </v-container>
        </div>

        <RegisterForm
            v-else-if="company"
            :prefill="company"
            :readonly="false"
            @triggered-company-update="saveDraft"
        />
    </div>
</template>

<script>
import axios from "axios";
import RegisterForm from "@/views/RegisterForm.vue";
import { showAlertModal } from "@/utils";

export default {
    name: "CompanyOnboarding",
    components: { RegisterForm },

    data() {
        return {
            company: null,
            loaded: false,
            error: false, // ← track “not found”
        };
    },

    async mounted() {
        const token = this.$route.query.tid;
        if (!token) {
            return this.$router.replace("/");
        }

        try {
            const { data } = await axios.get(
                `${process.env.VUE_APP_API_URL}/company-onboarding/${token}/`
            );
            this.company = data;
            this.loaded = true;
        } catch (err) {
            // only surface the “not found” error—everything else still bounces
            if (err.response && err.response.status === 404) {
                this.error = true;
                this.loaded = true;
            } else {
                // unexpected error? fall back to homepage
                this.$router.replace("/");
            }
        }
    },

    methods: {
        showAlertModal,
        async saveDraft(formData) {
            try {
                const token = this.$route.query.tid;
                await axios.post(
                    `${process.env.VUE_APP_API_URL}/company/${token}/pending-update/`,
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                this.showAlertModal(
                    this.$store,
                    this.$t("register.updateSentForApproval"),
                    "success",
                    5000
                );
                this.$router.push("/registration-pending");
            } catch (e) {
                console.error(e);
                this.showAlertModal(
                    this.$store,
                    this.$t("common.errorTryLater"),
                    "danger",
                    12000,
                    e
                );
            }
        },
    },
};
</script>

<style scoped>
.no-company {
    min-height: 60vh;
}
</style>
